import { Button, Stack, Typography } from '@mui/material';
import React from 'react';

export default function CurrentServiceCard({ title, buttonTitle, status, onPress }) {
  return (
    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
      <Typography>{title}</Typography>
      <Button variant="outlined" onClick={onPress}>
        {buttonTitle}
      </Button>
    </Stack>
  );
}
